import React from 'react';
import useStore from '@data/state/zustand';

export interface InvoicingProps {
    children?: any;
}
const InvoiceFooter = (props: InvoicingProps) => {
    const invoicingSettings = useStore((appState: any) => appState.invoicingSettings);

    let invoiceNotes = invoicingSettings && invoicingSettings.invoiceNotes ? invoicingSettings.invoiceNotes : '';

    return (
        <div className="mt-3 mb-3">
            <small dangerouslySetInnerHTML={{ __html: invoiceNotes }}></small>
        </div>
    );
};

export default InvoiceFooter;
